import React from 'react';
import { twMerge } from 'tailwind-merge';

interface DropdownOption<T> {
  label: string;
  value: T;
}

interface DropdownSelectProps<T> {
  options: DropdownOption<T>[];
  value: T;
  setValue: (value: T) => void;
  className?: string;
  label?: string;
  required?: boolean;
}

export default function DropdownSelect<T extends string | number>({
  options,
  value,
  setValue,
  className = '',
  label,
  required = false,
}: DropdownSelectProps<T>): JSX.Element {
  return (
    <div className="flex flex-col">
      {label && (
        <label className="mb-1 pr-2 font-medium text-primary-900">
          {label}
          {required && '*'}
        </label>
      )}
      <select
        value={String(value)}
        onChange={(e) => {
          const selected = options.find((opt) => String(opt.value) === e.target.value);
          if (selected) setValue(selected.value);
        }}
        className={twMerge('w-full rounded-lg border-none bg-secondary p-2 text-primary-900', className)}>
        {options.map((option) => (
          <option key={String(option.value)} value={String(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
